
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"51","height":"51","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"25.489","cy":"25.398","r":"25.357","fill":"#CC3434"}}),_c('path',{attrs:{"d":"M39.992 15.245a9.67 9.67 0 00-13.693 0L25.15 16.4l-1.149-1.15A9.677 9.677 0 0010.31 28.93L25.15 43.756l14.842-14.82a9.67 9.67 0 000-13.691z","fill":"#fff"}}),_c('path',{attrs:{"d":"M15.297 28.08h1.133v-2.213h2.299v2.213h1.13v-5.357h-1.13v2.21h-2.3v-2.21h-1.132v5.357zM21.925 22.723h-1.133v5.357h1.133v-5.357zM22.857 28.08h1.132v-1.737h.952c1.232 0 1.95-.735 1.95-1.804 0-1.065-.704-1.816-1.92-1.816h-2.114v5.357zm1.132-2.644v-1.787h.764c.654 0 .97.356.97.89 0 .53-.316.897-.965.897h-.769zM27.93 28.08l.398-1.221h1.933l.398 1.221h1.213l-1.846-5.357h-1.46l-1.85 5.357h1.214zm.686-2.105l.659-2.027h.042l.659 2.027h-1.36zM33.44 28.08l.398-1.221h1.933l.397 1.221h1.214l-1.847-5.357h-1.46l-1.849 5.357h1.214zm.685-2.105l.66-2.027h.041l.66 2.027h-1.36z","fill":"#CC3434"}})])
          )
        }
      }
    